module.exports = __webpack_public_path__ + "static/img/背景板(1).70078331.png";